import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface FrameProps {
  id: string;
  /** Mono eyebrow — the section's label in the machine's own voice. */
  label: string;
  children: ReactNode;
  className?: string;
}

/**
 * Section shell for the marketing page: a hairline-topped band, a mono label
 * (the "system readout" motif), and generous vertical rhythm. Deliberately not
 * a centered header + card grid — content sets its own asymmetric layout.
 */
export function Frame({ id, label, children, className }: FrameProps) {
  return (
    <section id={id} className={cn('scroll-mt-20 border-t border-white/8', className)}>
      <div className="mx-auto max-w-6xl px-6 py-20 sm:py-28">
        <div className="mb-12 flex items-center gap-4">
          <span className="mkt-mono text-[11px] uppercase tracking-[0.22em] text-[color:var(--nq-blue-bright)]">
            {label}
          </span>
          <span className="h-px flex-1 bg-white/8" />
        </div>
        {children}
      </div>
    </section>
  );
}
